"use client";
import React, { forwardRef } from "react";
import { classNames } from "../../utilities/helpers.js";
import s from "./Actionable.module.css";
const Actionable = forwardRef((props, ref) => {
    const { children, href, onClick, type, disabled, insetFocus, borderRadius, as, fullWidth, className, attributes, } = props;
    const rootClassNames = classNames(s.root, className, disabled && s["--disabled"], borderRadius && s[`--radius-${borderRadius}`], insetFocus && s["--inset"], fullWidth && s["--full-width"]);
    const rootAttributes = { ...attributes };
    const repeatRef = React.useRef(false);
    const hasClickHandler = onClick || attributes?.onClick;
    const hasFocusHandler = attributes?.onFocus || attributes?.onBlur;
    const isLink = Boolean(href || attributes?.href);
    const isButton = Boolean(hasClickHandler || hasFocusHandler || type);
    let TagName;
    if (isLink) {
        rootAttributes.href = disabled ? undefined : href || attributes?.href;
        TagName = "a";
    }
    else if (isButton && (!as || as === "button")) {
        TagName = "button";
        rootAttributes.type = type || attributes?.type || "button";
        rootAttributes.disabled = disabled || attributes?.disabled;
    }
    else if (isButton) {
        const isFocusable = as === "label";
        const simulateButton = !isFocusable || hasClickHandler || hasFocusHandler;
        TagName = as || "span";
        rootAttributes.role = simulateButton ? "button" : undefined;
        rootAttributes.tabIndex = simulateButton ? 0 : undefined;
    }
    else {
        TagName = as || "span";
    }
    const handlePress = (event) => {
        if (disabled)
            return;
        /**
         * - Holding enter keep onClick getting triggered
         * - Storybook environment is triggering onClick twice on each enter press
         */
        if (repeatRef.current)
            return;
        onClick?.(event);
        attributes?.onClick?.(event);
    };
    const handleKeyDown = (event) => {
        const simulatingButton = rootAttributes.role === "button";
        // These cases are handled correctly by the browsers
        if (simulatingButton || isLink)
            return;
        const isSpace = event.key === " ";
        const isEnter = event.key === "Enter";
        if (!isSpace && !isEnter)
            return;
        event.preventDefault();
        handlePress(event);
        repeatRef.current = true;
        requestAnimationFrame(() => {
            repeatRef.current = false;
        });
    };
    return (React.createElement(TagName, { ref: ref, ...rootAttributes, className: rootClassNames, onClick: handlePress, onKeyDown: handleKeyDown }, children));
});
export default Actionable;
